import { render } from "./terBidNoti.vue?vue&type=template&id=17887a9c"
import script from "./terBidNoti.vue?vue&type=script&lang=js"
export * from "./terBidNoti.vue?vue&type=script&lang=js"

import "./terBidNoti.vue?vue&type=style&index=0&id=17887a9c&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__